import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {extractGtin14FromBarcode} from '../helpers/gs1Barcode';

const ENDPOINTS = {
  delete: '/products/delete_product.json',
  duplicate: '/products/duplicate_product.json',
  changeStatus: '/products/change_product_status.json',
  generateBarcode: '/products/generate_barcode.json',
  generateNumericBarcode: '/products/generate_numeric_barcode.json',
  printBarcodeLabels: '/products/print_product_barcode_label.json',
  printReceivingLabels: '/products/print_receiving_label.json',
  exportCsv: '/products/generate_products_csv',
  brokenImageExport: '/products/generate_broken_image'
};

const SUCCESS_MESSAGES = {
  delete: 'Delete Queued Successfully',
  duplicate: 'Duplicate Queued Successfully',
  changeStatus: 'Status Update Queued Successfully',
  generateBarcode: 'Barcode generation in progress',
  generateNumericBarcode: 'Numeric barcode generation in progress',
  printBarcodeLabels: 'Barcode Labels will be generated shortly',
  printReceivingLabels: 'Receiving Labels will be generated shortly',
  exportCsv: 'Your request has been queued. You will receive an email when products export is complete',
  brokenImageExport: 'Successfully Queued'
};

function buildPayload({
  selectedProducts = [],
  selectAll = false,
  unselectedIds = [],
  filter = 'active',
  search = '',
  status = '',
  sortInfo = null,
  isKit = 0
}) {
  const inverted = selectAll && unselectedIds.length > 0;
  const gtin14 = extractGtin14FromBarcode(search);

  return {
    productArray: inverted
      ? unselectedIds.map(id => ({ id }))
      : selectedProducts.map(p => ({ id: p.id })),
    select_all: selectAll,
    inverted,
    filter,
    search: (gtin14 || search)?.trim() || '',
    status,
    sort: sortInfo?.name || '',
    order: sortInfo?.dir === 1 ? 'ASC' : 'DESC',
    is_kit: isKit,
    limit: 20,
    offset: 0
  };
}

export async function executeProductBulkAction(action, params) {
  const endpoint = ENDPOINTS[action];

  if (!endpoint) {
    return { success: false, message: `Unknown action: ${action}` };
  }

  if (!params.selectAll && (!params.selectedProducts || params.selectedProducts.length === 0)) {
    return { success: false, message: 'Please select products to perform this action' };
  }

  try {
    const access_token = await AsyncStorage.getItem('access_token');
    const baseUrl = await AsyncStorage.getItem('url');
    const payload = buildPayload(params);

    const response = await axios({
      method: 'post',
      url: `${baseUrl}${endpoint}`,
      data: payload,
      headers: {
        Authorization: `Bearer ${access_token}`
      }
    });

    if (response.data && (response.data.status !== false)) {
      return {
        success: true,
        message: SUCCESS_MESSAGES[action] || 'Action queued successfully',
        data: response.data
      };
    } else {
      return {
        success: false,
        message: response.data?.messages || response.data?.error_msg || 'Action failed'
      };
    }
  } catch (error) {
    console.error(`Product bulk action (${action}) error:`, error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'An error occurred'
    };
  }
}

export const ACTION_MAP = {
  delete: 'delete',
  duplicate: 'duplicate',
  generate_barcode_sku: 'generateBarcode',
  generate_numeric_barcode: 'generateNumericBarcode',
  print_barcode_labels: 'printBarcodeLabels',
  print_receiving_labels: 'printReceivingLabels',
  export_csv: 'exportCsv',
  broken_image_export: 'brokenImageExport',
  active: 'changeStatus',
  inactive: 'changeStatus',
  new: 'changeStatus'
};

